import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import DomotiqueHero from './components/DomotiqueHero';
import DomotiqueFeatures from './components/DomotiqueFeatures';
import DomotiqueGrid from './components/DomotiqueGrid';
import SEOHead from '@/components/feature/SEOHead';

const schema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Domotique Maison Connectée Neuenegg - CasaReNovaPlus",
  "provider": {
    "@type": "LocalBusiness",
    "name": "CasaReNovaPlus",
    "telephone": "+41797616282",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Meyrin",
      "addressRegion": "Genève",
      "addressCountry": "CH"
    }
  },
  "areaServed": ["Genève", "Lausanne", "Vaud", "Fribourg", "Valais", "Suisse Romande"],
  "description": "Installation de systèmes domotiques KNX et maison connectée à Genève et en Suisse romande. Automatisation, sécurité, éclairage intelligent.",
  "serviceType": "Domotique KNX",
  "url": `${import.meta.env.VITE_SITE_URL}/domotique`
};

export default function Domotique() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Domotique Neuenegg | Maison Connectée Suisse Romande - CasaReNovaPlus"
        description="CasaReNovaPlus : installation domotique et maison connectée à Neuenegg et en Suisse romande. Automatisation, sécurité, éclairage intelligent. Devis gratuit."
        keywords="domotique Genève, maison connectée Genève, smart home Suisse romande, automatisation maison Genève, KNX Genève, domotique Lausanne Vaud"
        canonical={`${import.meta.env.VITE_SITE_URL}/domotique`}
        schema={schema}
      />
      <Header />
      <DomotiqueHero />
      <DomotiqueFeatures />
      <DomotiqueGrid />
      <Footer />
    </div>
  );
}
